// BBC News Article colours
export var C_EBON = '#222222';
export var C_POSTBOX = '#B80000';
export var C_STORM = '#404040';
export var C_WHITE = '#FFFFFF';
export var C_BLUEJAY = '#0F556C';
export var C_BLUEJAY_LHT = '#C3DEE7';
export var C_OAT_LHT = '#F5F3F1';
export var C_PEBBLE = '#AEAEB5';
export var C_RHINO = '#5A5A5A';
export var C_STONE = '#D5D0CD';
export var C_CHALK = '#ECEAE7';
export var C_SHADOW = '#3F3F42';
export var C_CLOUD_DARK = '#757575';
export var C_CLOUD_LIGHT = '#BABABA';
export var C_LUNAR = '#F2F2F2';
export var C_LUNAR_LIGHT = '#F8F8F8';
export var C_GHOST = '#FDFDFD';
export var C_METAL = '#6E6E73';
export var C_KINGFISHER = '#11708C';
export var C_MIDNIGHT_BLACK = '#121212'; // Colours from other BBC services

export var C_CONSENT_BACKGROUND = '#323232';
export var C_CONSENT_ACTION = '#F6A21D';
export var C_CONSENT_CONTENT = '#BEBEBE';
export var C_ORBIT_GREY = '#4C4C4C';
export var C_DARK_SALTIRE = '#23104C';
export var C_WEATHER_BLUE = '#067EB3';
export var C_ARCHIVE_BLUE = '#3A549C';
export var C_LE_TEAL = '#09838B';
export var C_NEWSROUND_PURPLE = '#6C22D6';
export var C_SPORT_YELLOW = '#FFD230';
export var C_BLACK = '#000000';